/*
 * Dash list — keeps every .dwm-dash-list bullet (the short green dash, dwm-components.css) exactly the same on screen.
 *
 * Why: on scaled displays (e.g. Windows at 125% or 175%, or browser zoom) one CSS pixel is not a whole screen pixel.
 * The browser rounds every box to whole screen pixels, so a 2 px dash (2.5 screen pixels at 125%) becomes 2 or 3
 * pixels high depending on where it lands. Expressed in whole screen pixels (3 at 125% = 2.4 px) it always rounds to
 * the same size. This sets --dwm-dash-w and --dwm-dash-h to the nearest whole number of screen pixels for 8 × 2 px,
 * and updates them when the pixel ratio changes (zoom, moving the window to another screen). Without JavaScript the
 * CSS fallback of 8 × 2 px applies.
 */

const DASH_W = 8;
const DASH_H = 2;

function update() {
  const dpr = window.devicePixelRatio || 1;
  const root = document.documentElement;
  root.style.setProperty('--dwm-dash-w', `${Math.max(1, Math.round(DASH_W * dpr)) / dpr}px`);
  root.style.setProperty('--dwm-dash-h', `${Math.max(1, Math.round(DASH_H * dpr)) / dpr}px`);
  // Watch for the next change of the pixel ratio.
  window.matchMedia(`(resolution: ${dpr}dppx)`).addEventListener('change', update, { once: true });
}

if (!window.dwmDashList) {
  window.dwmDashList = true;
  update();
}
